module.exports = __webpack_public_path__ + "3768cd290b832522d83c91697d362dc7.svg";